import { useState } from "react"

export const TrainingState = () => {
	 const [trainingForm, setTrainingForm] = useState({open: false, code: '', id: '', training_name: '', training_type: '', training_date: '', training_start: '', training_end: '', location: '', training_fee: 'free', training_price: '', meeting_link: '', meeting_id: '', meeting_pass: '', confirmation: false, error: false, loader: false, method: 'create', active: true, show_shop: false})
    const dfltForm = [
        {open: false, code: '', id: '', training_name: '', training_type: '', training_date: '', training_start: '', training_end: '', location: '', training_fee: 'free', training_price: '', meeting_link: '', meeting_id: '', meeting_pass: '', confirmation: false, error: false, loader: false, method: 'create', active: true, show_shop: false}
    ]
    const [trainingList, setTrainingList] = useState([])
    const [totalList, setTotalList] = useState(0)
    const [loader, setLoader] = useState(false)
    const [page, setPage] = useState(1)
    const [hasMore, setHasMore] = useState(true)
	const [paymentInfo, setPaymentInfo] = useState([
		{ training_fee_id: '', training_fee_type_id: '', name: '', regularPrice: '', voucherCode: '', discount: '', price: 0 , voucherEnabled: false, loader: false, requiredPRC: false, showInShop: false, active: 1, temp_id: crypto.randomUUID() }
	])
	const dfltPaymentInfo = { training_fee_id: '', training_fee_type_id: '', name: '', regularPrice: '', voucherCode: '', discount: '', price: 0 , voucherEnabled: false, loader: false, requiredPRC: false, showInShop: false, active: 1, temp_id: crypto.randomUUID() }
	
	return {
		trainingForm: {data: trainingForm, set: setTrainingForm},
        dfltForm: {data: dfltForm},
        trainingList: {data: trainingList, set: setTrainingList},
        totalList: {data: totalList, set: setTotalList},
        loader: {data: loader, set: setLoader},
        page: {data: page, set: setPage},
        hasMore: {data: hasMore, set: setHasMore},
		paymentInfo: {data: paymentInfo, set: setPaymentInfo},
		dfltPaymentInfo: {data: dfltPaymentInfo},
	}
}